import ApolloClient, { InMemoryCache } from "apollo-boost";
import { environment } from "../environments/environment";
import * as Cookies from "es-cookie";
let client;
export function getApolloClient() {
    if (!client) {
        client = new ApolloClient({
            uri: environment.gatewayEndpoint,
            cache: new InMemoryCache({
                resultCaching: true,
                addTypename: false
            }),
            request: async (operation) => {
                const authToken = window && window.hasOwnProperty('AUTH_TOKEN') && window['AUTH_TOKEN'] ? window['AUTH_TOKEN'] : Cookies.get('auth_token');
                if (authToken) {
                    operation.setContext({
                        headers: {
                            Authorization: `Bearer ${authToken}`
                        }
                    });
                }
            }
        });
    }
    return client;
}
//# sourceMappingURL=graphql.js.map
